<template>
    <q-table
        v-if="purchaseNearList && purchaseNearList.length > 0"
        :title="`進貨物料有效日期提醒`"
        class="full-height"
        :data="purchaseNearList"
        :columns="purchaseColumns"
        :pagination.sync="purchaseTableSet"
    >
        <template v-slot:body="props">
        <q-tr :props="props">
            <q-td key="purchase" :props="props">
            <router-link :to="('purchase/offline-edit/'+props.row.PurchaseLocalProduct.purchase_id)" target="_blank">
                {{ props.row.PurchaseLocalProduct.Purchase.purchase_no }}
            </router-link>
            
            </q-td>
            <q-td key="title" :props="props">
            <ProductTitle :product-data="props.row.PurchaseLocalProduct.detail"/>
            </q-td>
            <q-td key="effective_date" :props="props">{{ props.row.PurchaseLocalProduct.effective_date }}</q-td>
            <q-td key="action" :props="props">
            <q-btn color="green" label="確認用完" @click="handleEffectiveCheckBtn(props.row.id)"></q-btn>
            </q-td>
        </q-tr>
        </template>
    </q-table>
</template>

<script>
    import { mapGetters } from "vuex"
    import ProductTitle from '@/components/ProductTitle'
    export default {
        name: "PurchaseEffective",
        components: { ProductTitle },
        data() {
            return {
                purchaseColumns: [
                { name: 'purchase', align: 'center', label: '採購單號', field: 'purchase'},
                { name: 'title', align: 'center', label: '物料', field: 'title'},
                { name: 'effective_date', align: 'center', label: '進貨有效日期', field: 'effective_date'},
                { name: 'action', align: 'center', label: '', field: 'action'},
                ],
                purchaseTableSet: {
                    sortBy: 'desc',
                    descending: false,
                    page: 1,
                    rowsPerPage: 5
                },
            }
        },
        computed: {
            ...mapGetters(['purchaseNearList'])
        },
        created() {
            this.$store.dispatch('purchaseGetEffectiveNear')
        },
        methods:{
            handleEffectiveCheckBtn(id){
                this.$q.dialog({
                        dark: true,
                        title: '確認！',
                        message: '是否確定此項已完整使用結清？',
                        cancel: true,
                        persistent: true
                    }).onOk(() => {
                        this.$store.dispatch("purchaseEffectiveCheckOver", id)
                    })
                
            },
        }
    }
</script>

<style>

</style>